import { Building2, Check, ChevronsUpDown } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { useAccountContext } from '@/auth/useAccountContext';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

export function AccountSwitcher() {
  const { accounts, activeAccountId, switch: switchAccount } = useAccountContext();
  const { t } = useTranslation('common');

  if (accounts.length <= 1) return null;
  const active = accounts.find((a) => a.id === activeAccountId);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" className="gap-2">
          <Building2 className="h-4 w-4" />
          <span className="max-w-[160px] truncate">
            {active?.name ?? t('topBar.switchAccount')}
          </span>
          <ChevronsUpDown className="h-3 w-3 opacity-60" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-64">
        <DropdownMenuLabel>{t('topBar.switchAccount')}</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {accounts.map((account) => (
          <DropdownMenuItem
            key={account.id}
            onSelect={() => void switchAccount(account.id)}
            className="gap-2"
          >
            {account.id === activeAccountId ? (
              <Check className="h-4 w-4" />
            ) : (
              <span className="h-4 w-4" />
            )}
            <span className="flex-1 truncate">{account.name}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
